import { render, staticRenderFns } from "./LexinKeyboardLangCkb.vue?vue&type=template&id=61bd324d&"
import script from "./LexinKeyboardLangCkb.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangCkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports